import { MockedProvider } from "@apollo/client/testing";
import React, { useMemo } from "react";
import { MockedAuthManager } from "../../contexts/AuthManager";
import { buildActivityTodo, buildUser } from "../factories";
import UserTodosScreen from "../../screens/user/UserTodos";
import { GET_ACTIVITY_TODO_FEED } from "../../graphql/activity";
import { ProfileType } from "../../__generated__/graphql";
import { ScrollView } from "react-native";
import type { Meta, StoryObj } from "@storybook/react";
import { MockedProfileSwitcherManager } from "../../contexts/ProfileSwitcherManager";

const StoryComponent = ({ profileType }: { profileType: ProfileType }) => {
    const mocks = [
        {
            request: {
                query: GET_ACTIVITY_TODO_FEED,
            },
            result: () => {
                return {
                    data: {
                        getActivityTodoFeed: [
                            buildActivityTodo({
                                id: "todo-1",
                                badgeUrl:
                                    "https://yoolk.ninja/wp-content/uploads/2022/04/OnePiece-Monkey-D-Luffy.png",
                            }),
                            buildActivityTodo({ id: "todo-2" }),
                        ],
                    },
                };
            },
        },
    ];
    const user = useMemo(buildUser, []);

    return (
        <MockedAuthManager user={user}>
            <MockedProfileSwitcherManager profileType={profileType}>
                <MockedProvider mocks={mocks}>
                    <UserTodosScreen />
                </MockedProvider>
            </MockedProfileSwitcherManager>
        </MockedAuthManager>
    );
};

const meta = {
    title: "Screens/Todos",
    component: StoryComponent,
    argTypes: {
        profileType: {
            options: [ProfileType.Worker, ProfileType.Client],
            control: { type: "radio" },
        },
    },
    decorators: [
        (StoryFn) => (
            <ScrollView>
                <StoryFn />
            </ScrollView>
        ),
    ],
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Worker: Story = {
    args: {
        profileType: ProfileType.Worker,
    },
};

export const Client: Story = {
    args: {
        profileType: ProfileType.Client,
    },
};
